import { apiUrl } from "../utils/api";

const urlMarketLocations = "/wp-json/markets/locations";

export const getMarketLocations = (id) =>
  $.ajax({
    method: "GET",
    url: apiUrl(urlMarketLocations),
    data: {
      id,
    },
  });
